import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/crga-dashboard/CRGADashboardResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/crgadashboard/v1`;
	}
	query(e, t) {
		return this.api.post(this.buildPath(`${n.baseUrl}/dataquery`), e, t);
	}
};
export { n as CRGADashboardResource };

//# sourceMappingURL=CRGADashboardResource.js.map